import { render, staticRenderFns } from "./OutrightsTournaments.vue?vue&type=template&id=8c64c7c2"
import script from "./OutrightsTournaments.vue?vue&type=script&lang=js"
export * from "./OutrightsTournaments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports